var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.667 10.5V7a4.667 4.667 0 0 0-9.333 0v3.5M4.19 12.077l-.7 7.467c-.199 2.123-.298 3.184.054 4.004a3.5 3.5 0 0 0 1.54 1.691c.783.428 1.85.428 3.982.428h9.867c2.133 0 3.199 0 3.982-.428a3.5 3.5 0 0 0 1.54-1.69c.352-.82.253-1.882.054-4.005l-.7-7.467c-.168-1.792-.252-2.689-.655-3.366a3.5 3.5 0 0 0-1.507-1.373C20.935 7 20.035 7 18.234 7H9.767c-1.8 0-2.701 0-3.413.338a3.5 3.5 0 0 0-1.507 1.373c-.404.677-.488 1.574-.656 3.366"
  })));
};
export default SvgCart;